import * as yup from 'yup';

export const defaultString = () => yup.string().max(80);

export const defaultRequiredString = () => defaultString().required();

export const emailString = () => yup.string().email();

export const country = countries => {
  return yup.string().oneOf(countries.map(c => c.short));
}

export const requiredCountry = countries => {
  return country(countries).required()
};

export const date = () =>
  yup.date().transform((value, originalValue) => {
    if (value instanceof Date && isFinite(value) && originalValue.length == 10) {
      // already casted to date object
      // correct for yups missing timezone offset
      const offset = new Date().getTimezoneOffset();
      value.setMinutes(value.getMinutes() - offset);
      return value;
    }

    if (typeof originalValue !== 'string') {
      return value;
    }
    
    // check for german date format (MM.DD.YYYY) in case browser doesn't support
    // input[type=date] (e.g. Safari or IE)
    const match = /^(\d{2})\.(\d{2})\.(\d{4})$/.exec(originalValue.trim());

    let isoDate = '';
    if (match !== null && match.length === 4) {
      isoDate = `${match[3]}/${match[2]}/${match[1]}`;
    } 

    if (isNaN(Date.parse(isoDate))) {
      return originalValue;
    } else {
      return new Date(isoDate);
    }
  });
